module.exports = __webpack_public_path__ + "static/media/siddharth-sakleshpur-trip-01.6428df44.png";